import React from "react";
import { Box, Paper, Stack, Typography, Tab, Tabs } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const ScrollableTabs = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Scrollable tabs
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          By default, left and right scroll buttons are automatically presented
          on desktop and hidden on mobile. (based on viewport width)
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor  language={"js"} value={"              <Tabs\n" +
              "                value={value}\n" +
              "                onChange={handleChange}\n" +
              "                variant=\"scrollable\"\n" +
              "                scrollButtons=\"auto\"\n" +
              "                aria-label=\"scrollable auto tabs example\"\n" +
              "              >\n" +
              "                <Tab label=\"Item One\" />\n" +
              "                <Tab label=\"Item Two\" />\n" +
              "                <Tab label=\"Item Three\" />\n" +
              "                <Tab label=\"Item Four\" />\n" +
              "                <Tab label=\"Item Five\" />\n" +
              "                <Tab label=\"Item Six\" />\n" +
              "                <Tab label=\"Item Seven\" />\n" +
              "              </Tabs>"}>
            <Box sx={{ width: "100%" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
              >
                <Tab label="Item One" />
                <Tab label="Item Two" />
                <Tab label="Item Three" />
                <Tab label="Item Four" />
                <Tab label="Item Five" />
                <Tab label="Item Six" />
                <Tab label="Item Seven" />
              </Tabs>
            </Box>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default ScrollableTabs;
